{"mimecast_ui_package_version":"5.13.1","CDN_BASE_URL":"https://d2hlvp5lfy8w3p.cloudfront.net"}